import type { Accessorial, LTLShipment, LTLOffer, NormalizedShipmentDraft } from "@src/types/api";
import type { ShipmentDraft, DraftAccessorial } from "@src/load-agent/domain/shipmentDraft";
import type { LTLItem } from "@src/types/components";
import { EMPTY_NORMALIZED_LTL_DRAFT_ITEM } from "@shared/models/ltlEmptyLine";

export type NormalizedLTLShipment = ShipmentDraft & {
  offers: LTLOffer[];
  selectedOffers: string[];
  inferredFormFields?: Record<string, boolean>;
};
export type NormalizeLTLOpts = {
  providerId: string | null | undefined;
  accessorialDefaults: Accessorial[];
};
export function normalizeClickedShipment(
  clicked: LTLShipment,
  opts: NormalizeLTLOpts
): NormalizedLTLShipment {
  if (!clicked.normalizedDraft) {
    throw new Error(
      "normalizeClickedShipment: normalizedDraft is required — backend must normalize before sending."
    );
  }
  return buildFromNormalizedDraft(clicked, clicked.normalizedDraft, opts);
}

function buildFromNormalizedDraft(
  clicked: LTLShipment,
  nd: NormalizedShipmentDraft,
  opts: NormalizeLTLOpts
): NormalizedLTLShipment {
  const accessorials: Accessorial[] = opts.accessorialDefaults.map((acc) => {
    const fromDraft = nd.accessorials.find((a: DraftAccessorial) => a.apiName === acc.apiName);

    return { ...acc, checked: fromDraft?.checked ?? false };
  });
  const selectedOffers = (clicked.sentOffers ?? []).filter(
    (id): id is string => typeof id === "string" && id.length > 0
  );
  const items: LTLItem[] = nd.items.map((i) => ({ ...i, nmfc: i.nmfc ?? undefined }));

  return {
    form: nd.form,
    shipmentMode: nd.shipmentMode,
    equipment: nd.equipment,
    items: items.length > 0 ? items : [{ ...EMPTY_NORMALIZED_LTL_DRAFT_ITEM }],
    accessorials,
    offers: clicked.quotedRates,
    selectedOffers,
    inferredFormFields: nd.inferredFormFields ? { ...nd.inferredFormFields } : undefined,
  };
}
